"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M8 7c0 2.2091 1.7909 4 4 4 2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4zm6 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2zm3.9931 12A4.533 4.533 0 0018 18.75c0-3.5763-1.3023-4.75-6-4.75s-6 1.1737-6 4.75c0 .1092.0038.1914.007.25H17.993zM12 12c-6.0137 0-8 2.25-8 6.75 0 1.5.6667 2.25 2 2.25h12c1.3333 0 2-.75 2-2.25 0-4.5-1.9863-6.75-8-6.75z",
  clipRule: "evenodd"
})), 'UserIcon');
/* eslint-enable */


exports["default"] = _default;